export const statistics = {
  totalSentToday: 47,
  inQueue: 3,
  processing: 1,
  failed: 2
};

export const billingData = {
  currentMonth: 3250,
  messagesSent: 1625,
  averageCostPerMessage: 2,
  monthlyGrowth: 15
};
